import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Input, Select, Table } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { UserContext } from "../../../context/userContext";
import { AllUser } from "../../../Data/data_user";
import { GET, PATCH } from "../../../services";
import {
  CHECHKER_GET_ALL_USER,
  CHECHKER_UPDATE_REMOVE_USER,
  CHECHKER_UPDATE_ROLE_USER,
} from "../../../services/path";
import DeleteUserModal from "./view/DeleteUserModal";
import EditUserModal from "./view/EditUserModal";

const UserAll = () => {
  const [data, setData] = useState<AllUser[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [searchValue, setSearchValue] = useState("");
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [userToDelete, setUserToDelete] = useState<AllUser | null>(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [userToEdit, setUserToEdit] = useState<AllUser | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { user } = useContext(UserContext);
  const tableRef = useRef<HTMLDivElement | null>(null);
  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const pageOptions = ["10", "25", "50", "100"];
  const fetchData = async () => {
    try {
      const searchOrder = CHECHKER_GET_ALL_USER;
      const result = await GET(searchOrder);
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (value: string) => {
    setSearchValue(value.trim());
  };

  useEffect(() => {
    if (searchValue === "") {
      setFilteredData(data);
    } else {
      const filteredList = data.filter((item) => {
        return Object.values(item).some(
          (value) => value && value.toString().toLowerCase().includes(searchValue.toLowerCase()),
        );
      });

      setFilteredData(filteredList);
    }
  }, [searchValue, data]);

  useEffect(() => {
    if (tableRef.current) {
      const table = tableRef.current;
      const isOverflowing = table.scrollWidth > table.clientWidth;
      table.style.overflowX = isOverflowing ? "scroll" : "auto";
    }
  }, [data]);
  const handleEdit = (record: AllUser) => {
    setUserToEdit(record);
    setEditModalVisible(true);
  };

  const handleEditConfirmed = async (updatedRoleId: number | null) => {
    try {
      if (updatedRoleId !== null && userToEdit) {
        await PATCH(CHECHKER_UPDATE_ROLE_USER, {
          user_id: userToEdit.user_id,
          role_id: updatedRoleId,
          modified_by: user.user_id,
        });
      }

      fetchData();
    } catch (error) {
      console.error("Error updating record:", error);
    }
  };

  const handleDelete = (record: AllUser) => {
    setUserToDelete(record);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirmed = async () => {
    try {
      setDeleteModalVisible(false);
      await PATCH(CHECHKER_UPDATE_REMOVE_USER, {
        user_id: userToDelete?.user_id,
        modified_by: user.user_id,
      });

      fetchData();
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  const columns = [
    {
      title: <div style={{ textAlign: "center" }}>User ID</div>,
      dataIndex: "user_id",
      key: "user_id",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>Username</div>,
      dataIndex: "username",
      key: "username",
      render: (text: string) => (
        <div style={{ textAlign: "start" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>ชื่อ - นามสกุล</div>,
      dataIndex: "first-lastname",
      key: "first-lastname",
      render: (text: string, record: AllUser) => (
        <div style={{ textAlign: "start" }}>
          <span>
            {record.firstname} {record.lastname}
          </span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>ชื่อเล่น</div>,
      dataIndex: "nickname",
      key: "nickname",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>หน้าที่</div>,
      dataIndex: "role",
      key: "role",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>แก้ไข</div>,
      dataIndex: "edit",
      key: "edit",
      render: (text: string, record: AllUser) => (
        <div style={{ textAlign: "center" }}>
          <Button type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>ลบ</div>,
      dataIndex: "delete",
      key: "delete",
      render: (text: string, record: AllUser) => (
        <div style={{ textAlign: "center" }}>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record)}
          />
        </div>
      ),
    },
  ];

  return (
    <LoginedLayout>
      <ContentBox>
        <div
          style={{ marginBottom: "16px", borderBottom: "1px solid #e8e8e8", paddingBottom: "8px" }}
        >
          <h2 style={{ marginBottom: "8px" }}>พนักงานทั้งหมด</h2>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ flex: 3, marginRight: "8px" }}>
            <span>Show: </span>
            <Select
              value={pageSize.toString()}
              onChange={(value) => handlePageSizeChange(parseInt(value))}
            >
              {pageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
          </div>
          <div style={{ flex: 1 }}>
            <Input.Search
              placeholder="Search by User ID, Username, Name, Nickname..."
              onSearch={handleSearch}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>
        <div ref={tableRef}>
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{
              position: ["bottomRight"],
              pageSize: pageSize,
              showSizeChanger: false,
              onShowSizeChange: (_, size) => handlePageSizeChange(size),
              current: currentPage,
              onChange: (page) => setCurrentPage(page),
              total: filteredData.length,
            }}
          />
        </div>
      </ContentBox>
      <EditUserModal
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        onConfirm={handleEditConfirmed}
        initialValues={userToEdit}
      />
      <DeleteUserModal
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        onConfirm={handleDeleteConfirmed}
      />
    </LoginedLayout>
  );
};

export default UserAll;
